import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Contract, User, UserService } from '@api';
import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, of, pipe, switchMap, tap } from 'rxjs';

export interface UserStateInterface {
  user: User;
  loadUser: boolean;
  contract: Contract;
}

export const UserStore = signalStore(
  withState<UserStateInterface>({
    user: { id: -1, contracts: [] },
    loadUser: true,
    contract: { id: -1, name: '', code: '', legalEntityId: -1 },
  }),
  withMethods(
    (store, router = inject(Router), userService = inject(UserService)) => ({
      loadUserContracts: rxMethod<void>(
        pipe(
          tap(() => patchState(store, { loadUser: true })),
          switchMap(() => userService.getUser()),
          tap((user) => {
            if (user?.contracts[0]) {
              patchState(store, { contract: user.contracts[0] });
            }
            patchState(store, { user, loadUser: false });
          }),
          catchError(() => {
            router.navigateByUrl('/error');
            patchState(store, { loadUser: false });
            return of();
          })
        )
      ),
      setCurrentContract(contract: Contract) {
        patchState(store, { contract });
      },
    })
  ),
  withHooks({
    onInit(store) {
      store.loadUserContracts();
    },
  })
);
